import type { LocationModel } from '@reducers/orm/location/location.model';
import type { ObjectMap } from '@reducers/orm/orm.interfaces';

export const scopeLocationName = (locationIds: string[] | null, locations: ObjectMap<LocationModel>): string | null => {
  if (locationIds?.length !== 1) {
    return null;
  }

  return locations[locationIds[0]]?.name ?? null;
};
